import { computeEGD, computeLGD } from "./lineup";

// Resolve the user's XI + numbers for a live fixture.
// Uses submitted XI when present, otherwise the seeded demoUserXI.
export function userResult(fixture, submission) {
  if (!fixture || !fixture.homeSquad) return null;
  const src = submission && submission.assignment ? submission : fixture.demoUserXI;
  const egd = computeEGD(src.assignment, fixture.homeSquad);
  const lgd = computeLGD(fixture.optimalEGD, egd);
  return {
    assignment: src.assignment,
    formation: src.formation,
    egd,
    lgd,
    isSubmitted: !!(submission && submission.assignment),
  };
}

export function comparisonEntities(fixture, submission) {
  const you = userResult(fixture, submission);
  return {
    you,
    coach: fixture.coachXI,
    ai: fixture.aiXI,
    optimal: fixture.optimalXI,
  };
}
